import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MasterInformationService } from '../../../Services/master-information.service';
import { apiEndPoints } from '../../../api/apiEndPoint';
import {
  NgbModal,
  NgbPaginationModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
 
@Component({
  selector: 'app-zones',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgbTooltipModule,
  ],
  templateUrl: './zones.component.html',
  styleUrls: ['./zones.component.css'],
})
export class ZonesComponent implements OnInit {
  page = 1;
  pageSize = 10;
  pageSizeOptions = [5, 10, 25, 50, 100];
  createZoneForm: FormGroup;
  cityData: any = [];
  filteredCities: any = [];
  selectCityData: any = [];
  zoneNames: string[] = [];
  selectedFilterStatus = '';
  selectedFilterCity = '';
  currentCityForStatusChange: any = null;
  zoneStatus: any;
  zoneId: any;
  cityId: any;
  isActiveDropdown: any;
  cityStatus: any;
  cityFilterApplied: boolean = false;
  noDataMessage: string = ''; // Custom message when no data found
  selectedZoneFilter: any;
 
  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private masterService: MasterInformationService,
    private cdr: ChangeDetectorRef
  ) {
    this.createZoneForm = this.fb.group({
      cityName: ['', Validators.required],
      zoneName: ['', Validators.required],
    });
  }
 
  ngOnInit(): void {
    this.getZoneList();
    this.getCityList();
  }
 
  // -------------------------------------- Pagination -------------------------------------- //
 
  get pagedData() {
    const start = (this.page - 1) * this.pageSize;
    const end = this.page * this.pageSize;
    return this.filteredCities?.slice(start, end);
  }
 
  onPageChange(page: number): void {
    this.page = page;
  }
 
  onPageSizeChange(): void {
    this.page = 1;
  }
 
  // -------------------------------------- Input Search -------------------------------------- //
 
  search(event: Event): void {
    const query = (event.target as HTMLInputElement).value.toLowerCase();
    if (!this.filteredCities.length) {
      this.filteredCities = [...this.cityData];
    }
 
    if (query) {
      this.filteredCities = this.cityData.filter(
        (city: any) =>
          city.cityName?.toLowerCase().includes(query) ||
          city.zoneName?.toLowerCase().includes(query)
      );
    } else {
      this.filteredCities = [...this.cityData];
    }
  }
 
  // -------------------------------------- Open Modal -------------------------------------- //
 
  openCreateZoneModal(content: any): void {
    this.createZoneForm.reset();
    this.modalService.open(content, { backdrop: 'static', centered: true });
  }
 
  // -------------------------------------- Get City List API -------------------------------------- //
 
  getCityList(): void {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        this.selectCityData = response.body.details.filter(
          (data: any) => data.cityStatus !== false
        );
        this.filteredCities = [...this.cityData];
      },
      error: (error) => {
        this.toastr.error(
          'Error fetching city list. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }
 
  // -------------------------------------- Add Zone API -------------------------------------- //
 
  addNewZone(modal: any): void {
    if (this.createZoneForm.valid) {
      const reqBody = {
        cityId: this.createZoneForm.value.cityName.id,
        Zone: this.createZoneForm.value.zoneName,
      };
      this.masterService.postZoneApi(reqBody, apiEndPoints.addZone).subscribe({
        next: (response) => {
          if (response.statusText === 'Zone Already Exist') {
            this.toastr.warning(
              'Zone already exists. Please try another name.',
              'Warning',
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true,
              }
            );
            this.createZoneForm.controls['zoneName'].setErrors({
              exists: true,
            });
          } else {
            modal.close();
            this.toastr.success(
              'Your Zone has been added successfully!',
              'Success',
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true,
              }
            );
            this.createZoneForm.reset();
            this.getZoneList();
          }
        },
        error: (error) => {
          this.toastr.error(
            'Error Adding Zone. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
    } else {
      this.createZoneForm.markAllAsTouched();
    }
  }
 
  // -------------------------------------- Get Zone List API -------------------------------------- //
 
  getZoneList() {
    this.masterService.getZoneList(apiEndPoints.zoneList).subscribe({
      next: (response) => {
        this.cityData = response.body.details;
        console.log(this.cityData);
        this.filteredCities = [...this.cityData];
        this.filteredCities = this.cityData.filter(
          (city: any) => city.cityStatus
        );
        this.zoneNames = Array.from(
          new Set(this.cityData.map((city: any) => city.zoneName))
        );
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toastr.error(
          'Error fetching zone list. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }
 
  // -------------------------------------- Zone Active & InActive API  -------------------------------------- //
 
  openChangeStatusPopup(content: any, city: any): void {
    this.currentCityForStatusChange = { ...city };
    this.cityId = city.cityId;
    this.zoneId = city.zoneId;
    this.modalService.open(content, { centered: true, backdrop: 'static' });
  }
 
  changeZoneStatus(modal: any): void {
    const toggledStatus = !this.currentCityForStatusChange.zoneStatus;
 
    this.masterService
      .postActiveInactiveZone(
        apiEndPoints.ZoneStatusUpdate,
        this.cityId,
        this.zoneId,
        toggledStatus
      )
      .subscribe({
        next: (response: any) => {
          modal.close(); // Close the modal after success
          this.currentCityForStatusChange.zoneStatus = toggledStatus;
 
          this.toastr.success(
            `Zone "${
              this.currentCityForStatusChange.zoneName
            }" status changed to ${
              this.currentCityForStatusChange.zoneStatus ? 'Active' : 'Inactive'
            } successfully.`,
            'Status Updated',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
          this.getZoneList(); // Refresh the zone list after status change
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }
 
  getStatus(status: any): string {
    switch (status) {
      case true:
      case 'true':
      case 1:
        return 'Active';
      case false:
      case 'false':
      case 0:
        return 'Inactive';
      default:
        return 'Unknown';
    }
  }
 
  // ------------------------------- Export to Excel ------------------------------- //
 
  // exportToExcel(): void {
  //   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.cityData);
  //   const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
  //   XLSX.writeFile(wb, 'ZoneList.xlsx');
  // }
 
  exportToExcel(): void {
  // Build data exactly like the PDF table
  const formattedData = this.cityData.map((city: any, index: number) => {
    const formattedDate = new Date(city.createdDate).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
 
    return {
      'S.No': index + 1,
      'City Name': city.cityName,
      'Zone Name': city.zoneName,
      'Date Created': formattedDate,
      'Status': this.getStatus(city.cityStatus),
    };
  });
 
  // Create a worksheet from formatted data
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
 
  // Optional: Adjust column widths for readability
  ws['!cols'] = [
    { wch: 6 },   // S.No
    { wch: 25 },  // City Name
    { wch: 25 },  // Zone Name
    { wch: 20 },  // Date Created
    { wch: 15 },  // Status
  ];
 
  // Create workbook and export it
  const wb: XLSX.WorkBook = { Sheets: { 'Zone List': ws }, SheetNames: ['Zone List'] };
  XLSX.writeFile(wb, 'Zone_List.xlsx');
}
 
 
  // -------------------------------------- Table Filter -------------------------------------- //
 
  applyCityFilter(cityName: string): void {
    this.selectedFilterCity = cityName;
    if (cityName) {
      this.cityFilterApplied = true;
      this.filteredCities = this.cityData.filter(
        (city: any) => city.cityName === cityName
      );
      this.noDataMessage =
        this.filteredCities.length === 0
          ? 'No zone available for the selected city'
          : '';
    } else {
      this.cityFilterApplied = false;
      this.filteredCities = [...this.cityData];
      this.noDataMessage = '';
    }
    this.applyFilter(); // Reapply the filters after city filter is applied
  }
 
  applyZoneFilter(zoneName: string): void {
    this.selectedZoneFilter = zoneName;
    this.applyFilter();
  }
 
  toggleStatusFilter(status: string): void {
    this.selectedFilterStatus = status;
    this.applyFilter();
  }
 
  applyFilter(): void {
    let filtered = [...this.cityData]; // Start with all data
 
    // Apply city filter if selected
    if (this.selectedFilterCity) {
      filtered = filtered.filter(
        (city: any) => city.cityName === this.selectedFilterCity
      );
    }
 
    // Apply zone status filter if selected
    if (this.selectedFilterStatus) {
      filtered = filtered.filter(
        (city: any) =>
          this.getStatus(city.zoneStatus) === this.selectedFilterStatus
      );
    }
 
    if (this.selectedZoneFilter) {
      filtered = filtered.filter(
        (zone: any) => zone.zoneName === this.selectedZoneFilter
      );
    }
 
    this.filteredCities = filtered;
 
    // Check if there is no data after applying filters
    if (this.filteredCities.length === 0) {
      this.noDataMessage = this.cityFilterApplied
        ? 'No zone available for the selected city'
        : 'No Data Found';
    } else {
      this.noDataMessage = ''; // Clear the no data message if there is data
    }
  }
 
  printGrid(): void {
    console.log('Print triggered');
  }
 
  clearGrid(inputElement: HTMLInputElement): void {
    inputElement.value = ''; // ✅ clear text
    this.getZoneList();
  }
 
  getSerialNumber(index: number): number {
  return (this.page - 1) * this.pageSize + index + 1;
}
 
  // ------------------------------- Print List or Download PDF ------------------------------- //
 
  exportToPDF() {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const pdfFileName = 'Zone_List.pdf';
 
    const logo = new Image();
    logo.src = 'assets/Images/CDM-01.png';
    logo.onload = () => {
      const logoWidth = 28;
      const logoHeight = 20;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10;
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);
 
      const arabicAddressImg = new Image();
      arabicAddressImg.src = 'assets/Images/arabic address.jpeg';
      arabicAddressImg.onload = () => {
        const arabicImgWidth = 70;
        const arabicImgHeight = 20;
        const arabicImgX = pageWidth - arabicImgWidth - 10;
        const arabicImgY = 10;
        doc.addImage(
          arabicAddressImg,
          'JPEG',
          arabicImgX,
          arabicImgY,
          arabicImgWidth,
          arabicImgHeight
        );
 
        // Add website below Arabic address image
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 255);
        doc.text(
          'www.smart­sort.net',
          arabicImgX + arabicImgWidth / 2,
          arabicImgY + arabicImgHeight + 5,
          { align: 'left' }
        );
 
        const englishAddressImg = new Image();
        englishAddressImg.src = 'assets/Images/english address.jpeg';
        englishAddressImg.onload = () => {
          const englishImgWidth = 70;
          const englishImgHeight = 20;
          const englishImgX = 10;
          const englishImgY = 10;
          doc.addImage(
            englishAddressImg,
            'JPEG',
            englishImgX,
            englishImgY,
            englishImgWidth,
            englishImgHeight
          );
 
          // Add website below English address image
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 255);
          doc.text(
            'www.smart­sort.net',
            englishImgX + englishImgWidth / 11,
            englishImgY + englishImgHeight + 5,
            { align: 'left' }
          );
 
          // Reset text color to black (optional, in case you add more text later)
          doc.setTextColor(0, 0, 0);
 
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          const title = 'Zone List';
          const titleY = logoY + logoHeight + 10;
          doc.text(title, pageWidth / 2, titleY, { align: 'center' });
 
          // Table headers
          const headers = [
            [
               { content: 'S.No' }, // added S.No
              { content: 'City Name' },
              { content: 'Zone Name' },
              { content: 'Date Created' },
              { content: 'Status' },
            ],
          ];
 
          let tableBody: any[] = [];
          // Ensure Year is filled for every row
          this.cityData.forEach((city: any, index: number) => {
            const formattedDate = new Date(city.createdDate).toLocaleDateString(
              'en-GB',
              {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              }
            );
 
            let status = this.getStatus(city.cityStatus);
 
            tableBody.push([
                 index + 1, // ✅ S.No
              city.cityName,
              city.zoneName,
              formattedDate,
              status,
            ]);
          });
 
          // Generate table
          autoTable(doc, {
            startY: titleY + 10,
            head: headers,
            body: tableBody,
            styles: {
              fontSize: 8,
              cellPadding: 2,
              lineWidth: 0.3,
              lineColor: [50, 50, 50],
              halign: 'center',
            },
            theme: 'grid',
            headStyles: {
              fillColor: [176, 220, 101],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              lineColor: [50, 50, 50],
              lineWidth: 0.3,
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            margin: { top: titleY + 20 },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            didDrawPage: function (data) {
              const pageCount = doc.getNumberOfPages();
              doc.setFontSize(10);
              doc.text(
                `Page ${pageCount}`,
                pageWidth - 20,
                doc.internal.pageSize.height - 10
              );
            },
          });
 
          // Save the PDF
          doc.save(pdfFileName);
        };
      };
    };
  }
}